webpackJsonp([17475807462898],{

/***/ 1266:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/en/Catalog/Kodak/","langKey":"en"}}

/***/ })

});


// WEBPACK FOOTER //
// path---en-catalog-kodak-4f26e1f4e4c3e5fe012d.js